import { render, staticRenderFns } from "./PeerGroupSection.vue?vue&type=template&id=07ff22a4&scoped=true"
import script from "./PeerGroupSection.vue?vue&type=script&lang=js"
export * from "./PeerGroupSection.vue?vue&type=script&lang=js"
import style0 from "./PeerGroupSection.vue?vue&type=style&index=0&id=07ff22a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ff22a4",
  null
  
)

export default component.exports